export const modules = {
  toolbar: [
    ['bold', 'italic', 'strike', 'blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['emoji'],
  ],
  'emoji-toolbar': true,
  'emoji-textarea': false,
  'emoji-shortname': true,
  keyboard: {
    bindings: {
      tab: false,
      handleEnter: {
        key: 13,
        handler: function () {
          // Do nothing
        },
      },
    },
  },
};

export const Time =
  new Date(Date.now()).getHours() + ':' + new Date(Date.now()).getMinutes();
